import { cva } from '@/styled-system/css';

export const inputChipRootRecipe = cva({
  base: {
    'display': 'inline-flex',
    'alignItems': 'center',
    'verticalAlign': 'top',
    'borderRadius': 'shape.capsule',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
    },
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',
    'boxShadowColor': { base: 'border.action.hero.selected.default' },
    'paddingInlineStart': 'Chip.padding.horz',
    'backgroundColor': { base: 'bg.action.soft.selected.default' },

    '&:not(:has(.c11n_input-chip__close))': {
      paddingInlineEnd: 'Chip.padding.horz',
    },

    // Enables the flex child (InputChipLabel) to shrink and truncate
    'minWidth': '0',
  },
  variants: {
    elevated: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        'backgroundColor': 'bg.action.soft.selected.default/40',
        'boxShadowColor': 'border.action.hero.selected.default/40',

        '& .c11n_input-chip__label': {
          opacity: '0.6',
        },
        '& .c11n_input-chip__icon': {
          opacity: '0.6',
        },

        '& .c11n_input-chip__avatar': {
          opacity: 'disabled',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      elevated: true,
      disabled: false,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.sm}',
          _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  ],
});
